import NaijaStates from "naija-state-local-government";
import { useEffect, useState } from "react";
interface Option {
  label: string;
  value: string;
}

export default function useLgas(state: string): Option[] {
  const [theState, setTheState] = useState(state ?? "");

  useEffect(() => {
    if (state) setTheState(state);
  }, [state]);

  const result = NaijaStates.lgas(theState);
  if (!result || !result.lgas) {
    console.warn(`No LGAs found for state: ${state}`);
    return [];
  }

  return result.lgas.map((lga: string) => ({
    label: lga,
    value: lga,
  }));
}

// export default function useLgas(state: string) {
//   if (!state) return [];
//   return NaijaStates.lgas(state).lgas?.map((lga: string) => ({
//     label: lga,
//     value: lga,
//   }));
// }
